import React, { useState } from "react";
import { InputAdornment } from "@mui/material";
import RayaField from "./RayaField";

const NumberField = ({ value, onChange, onBlur, decimals = 0, min, max, ...props }) => {
    // Format in Turkish style
    const formatWithThousandSeparator = (number) => {
        if (number === null || number === undefined || number === "") return "";
        const [integerPart, decimalPart] = number.split(".");
        // Turkish: dot for thousands
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (decimals > 0 && decimalPart !== undefined) {
            // Turkish: comma for decimals
            return `${formattedInteger},${decimalPart.slice(0, decimals)}`;
        }
        return formattedInteger;
    };

    // Remove Turkish formatting → standard number
    const unformatNumber = (formattedNumber) =>
        formattedNumber.replace(/\./g, "").replace(",", ".");

    const handleChange = (event) => {
        const inputValue = event.target.value;
        const rawValue = unformatNumber(inputValue);

        // Allow intermediate states like "1," or ",5"
        if (!/^\d*(\.\d*)?$/.test(rawValue) && rawValue !== "") {
            return;
        }

        if (rawValue === "") {
            onChange && onChange(null);
            setInputValue("");
            return;
        }

        let numericValue = parseFloat(rawValue);
        if (!isNaN(numericValue)) {
            if (min !== undefined && numericValue < min) numericValue = min;
            if (max !== undefined && numericValue > max) numericValue = max;
        }

        const formattedValue =
            rawValue.endsWith(".") || rawValue.endsWith(",")
                ? inputValue
                : formatWithThousandSeparator(numericValue.toString());

        onChange && onChange(numericValue);
        setInputValue(formattedValue);
    };

    const handleBlur = () => {
        const rawValue = unformatNumber(inputValue);
        const numericValue = parseFloat(rawValue);

        if (rawValue.trim() === "") {
            onBlur && onBlur(null);
            return;
        }

        if (!isNaN(numericValue)) {
            let clampedValue = numericValue;
            if (min !== undefined && clampedValue < min) clampedValue = min;
            if (max !== undefined && clampedValue > max) clampedValue = max;

            const formatted = formatWithThousandSeparator(clampedValue.toString());
            setInputValue(formatted);
            onBlur && onBlur(clampedValue);
        } else {
            onBlur && onBlur(null);
        }
    };

    const [inputValue, setInputValue] = useState(
        formatWithThousandSeparator(value?.toString() || "")
    );

    return (
        <RayaField
            {...props}
            value={inputValue}
            onChange={handleChange}
            onBlur={handleBlur}
            slotProps={{
                htmlInput: {
                    inputMode: "decimal",
                    // Allow comma or dot but internally only dot matters
                    pattern: `[0-9]*(\\,?[0-9]{0,${decimals}})?`,
                },
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            {props.endAdornment}
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default NumberField;
